import { useEffect, useState } from "react";
import { Select, MenuItem, IconButton, Tooltip } from "@mui/material";
import i18next from "i18next";
import useAuth from "../hooks/useAuth";
import { useLocation } from "react-router-dom";
import Flag from "react-flagkit";

const languages = {
  en: {
    en: "English",
    is: "Enska",
    flagCode: "GB",
  },
  is: {
    en: "Icelandic",
    is: "Íslenska",
    flagCode: "IS",
  },
};
export default function LanguageDropdown() {
  const { id: userId } = useAuth();
  const [selectedLanguage, setSelectedLanguage] = useState("is");
  const location = useLocation();

  useEffect(() => {
    if (
      localStorage.getItem("i18nextLng") &&
      !userId &&
      !location.pathname.includes("/login")
    ) {
      i18next.changeLanguage("is");
    } else if (localStorage.getItem("i18nextLng")) {
      i18next.changeLanguage(localStorage.getItem("i18nextLng"));
      setSelectedLanguage(localStorage.getItem("i18nextLng"));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLanguageChange = (e) => {
    const language = e.target.value;
    setSelectedLanguage(language);
    i18next.changeLanguage(language);
  };

  return (
    <Select
      value={selectedLanguage}
      onChange={handleLanguageChange}
      variant="outlined"
      fullWidth
      MenuProps={{
        sx: {
          "& .MuiList-root": {
            padding: "10px 4px", // Adjust margin top between items
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "8px",
          },
          "& .MuiMenu-paper": {
            marginTop: "8px",
            borderRadius: "20px",
          },
        },
      }}
      sx={{
        width: "40px",
        height: "40px",
        padding: "0px !important",
        overflow: "hidden",

        "& .MuiSelect-icon": {
          display: "none",
        },
        backgroundColor: "#fff",
        borderRadius: "50%",
        border: "1px solid #222222",
        "& .MuiOutlinedInput-input": {
          padding: "1px !important", // Or adjust the value as needed
        },
        "& .MuiIconButton-root": {
          padding: 0,
          marginLeft: "-10px",
        },
      }}
    >
      {Object.keys(languages).map((key) => (
        <MenuItem
          key={key}
          value={key}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "40px",
            height: "40px",
            overflow: "hidden",
            borderRadius: "50%",
            border: "1px solid #B1CCFB",
          }}
        >
          <Tooltip
            title={languages[key][selectedLanguage]}
            placement="left"
            color="#EB9D84"
          >
            <IconButton color="primary">
              <Flag country={languages[key].flagCode} size={55} />
            </IconButton>
          </Tooltip>
        </MenuItem>
      ))}
    </Select>
  );
}
